import { Typography } from "@mui/material";

export default function Copyright() {
  return (
    <Typography variant="body2" color="footer.text">
      © {new Date().getFullYear()} Hogeschool Utrecht
    </Typography>
  );
}
